module.exports = "/assets/data/14e3e36f7fe5fdb7c115afbbf7154574-B27.data.json";